import React from "react";
import { View, Text, StyleSheet, ScrollView } from "react-native-web";

const Instructions = () => {
    return (
        <ScrollView contentContainerStyle={styles.scrollContainer}>
            <View style={styles.container}>
                <Text style={styles.title}>How to Play</Text>
                <Text style={styles.text}>
                    Welcome to the ultimate word challenge! 🚀
                </Text>
                <Text style={styles.text}>
                    Every day, three mysterious words await you—one with 4 letters, one with 5, and one with 6. But here’s the twist: the letters are shuffled up, and two have gone missing! 🌀🔤
                </Text>
                <Text style={styles.text}>
                    You’ll have 100 seconds to solve each puzzle. Sounds simple? Think again! Every 12 seconds, we’ll toss you a clue by revealing a hidden letter. But beware—every wrong guess costs you 2 seconds! ⏱️❌
                </Text>
                 <Text style={styles.text}>
                    Guesses can be helpful, if you guess a letter in the correct position of the word it will be highlighted green in your guesses 🟢. If you guess a correct letter in an incorrect position it will be yellow 🟡. If you guess a letter thats not in the word it will be white ⚪️.
                </Text>
                <Text style={styles.text}>
                    Your mission: Decode the word as fast as you can before time runs out. Can you beat the clock? 🌟
                </Text>
                <View style={{ height: "3%" }} />

                <View style={styles.letterContainer}>
                    {"thank".split("").map((letter, index) => (
                        <View
                            key={index}
                            style={styles.letterBox}
                        >
                            <Text style={styles.letterText}>
                                {letter.toUpperCase()}
                            </Text>
                        </View>
                    ))}
                </View>
                <View style={{ height: "3%" }} />
                <View style={styles.letterContainer}>
                    {"you!".split("").map((letter, index) => (
                        <View
                            key={index}
                            style={styles.letterBox}
                        >
                            <Text style={styles.letterText}>
                                {letter.toUpperCase()}
                            </Text>
                        </View>
                    ))}
                </View>
            </View>
        </ScrollView>
    );
};

const styles = StyleSheet.create({
    scrollContainer: {
        paddingVertical: 20,
    },
    container: {
    
        alignItems: "center",
    },
    title: {
        fontSize: 24,
        fontWeight: "bold",
        marginBottom: 10,
    },
    text: {
        fontSize: 16,
        marginVertical: 5,
        textAlign: "center",
    },
    letterContainer: {
        flexDirection: "row",
        justifyContent: "center",
        marginVertical: 5,
    },
    letterBox: {
        height: 40,
        width: 40,
        backgroundColor: "#27ae60", // Green box color
        justifyContent: "center",
        alignItems: "center",
        margin: 2, // Add space between the boxes
        borderRadius: 5, // Optional: rounded corners
    },
    letterText: {
        fontSize: 22,
        color: "white",
        fontWeight: "bold",
    },
});

export default Instructions;
